import "./Registration.css";
import Header from "../../Components/Shared/Header/Header";
import Footer from "../../Components/Shared/Footer/Footer";
import Modal from "../../Components/Modal/Modal";
import { useForm } from "react-hook-form";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Auth from "../../utils/api-utils";
import VivahApi from "../../api";
import { loadMasterData } from "../../masterData";
import { getUniqueRes } from "../../utils/api-utils";
import { calculateAge } from "../../utils/common";
import { PHONE_E164_WITH_10_DIGITS, PHONE_E164_MESSAGE } from "../../utils/validation";
import * as moment from "moment";

function Registration() {
  const formSchema = Yup.object().shape({
    user: Yup.object().shape({
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at 8 char long"),
      confirmPwd: Yup.string()
        .required("Password is required")
        .oneOf([Yup.ref("password")], "Passwords does not match"),
      email: Yup.string()
        .required("email is required")
        .matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i, "Enter Valid Email"),
      phone: Yup.string()
        .required("Phone Number is required")
        .matches(PHONE_E164_WITH_10_DIGITS, PHONE_E164_MESSAGE),
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      dateOfBirth: Yup.date()
        .max(
          new Date(Date.now() - 567648000000),
          "You must be at least 18 years"
        )
        .required("Required"),
    }),
    profile: Yup.object().shape({
      religionId: Yup.string().required("Religion is required"),
      casteId: Yup.string().required("Caste is required"),
      gender: Yup.string().required("Gender is required"),
      motherTongueId: Yup.string().required("MotherTongue required"),
    }),
  });
  const formOptions = { resolver: yupResolver(formSchema) };

  const { register, handleSubmit, formState, watch } = useForm(formOptions);
  const { errors } = formState;
  const navigate = useNavigate();
  const [religionId, setreligionId] = useState([]);
  const [casteId, setcasteId] = useState([]);
  const [gothraId, setGothraId] = useState([]);
  const [allCastes, setAllCastes] = useState([]);
  const [motherTongueId, setMotherTongueId] = useState([]);
  const [showGothras, setShowGothras] = useState(false);
  const [agree, setAgree] = useState(false);
  const [isReg, setIsReg] = useState(false);
  const [modal, setModal] = useState({ isOpen: false, type: 'info', title: '', message: '' });
  const [redirectTo, setRedirectTo] = useState(null);
  const [showGuardianPrompt, setShowGuardianPrompt] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [guardianPhone, setGuardianPhone] = useState('');
  let watchval = watch();
  // console.log(watchval, "watchval");

  useEffect(() => {
    const init = async () => {
      const data = await loadMasterData();
      setreligionId(data.religions);
      setGothraId(data.castes);
      setMotherTongueId(data.languages);
      setAllCastes(data.castes);
    };
    init();
  }, []);

  // Handle redirect after modal closes
  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo.path, { state: redirectTo.state });
      setRedirectTo(null);
    }
  }, [redirectTo, navigate]);

  const closeModal = () => {
    setModal({ ...modal, isOpen: false });
  };

  const handleReligionChange = async (e) => {
    // console.log(e.target.value);
    const rel = religionId.find((r) => Number(r.id) === Number(e.target.value));
    setShowGothras(rel && rel.value === "Hindu");
    // filter cached castes
    const filtered = (allCastes || []).filter(c => Number(c.religionId) === Number(e.target.value));
    setcasteId(filtered);
  };
  const onSubmit = async (data) => {
    try {
      // console.log(data, "signupdata");
      const isHindu = religionId.find((r) => r.value == "Hindu");
      if (isHindu.id != data.profile.religionId) {
        data.profile.gothraId = 0;
      }
      delete data.user.confirmPwd;
      
      const user = data.user;
      user.dateOfBirth = moment(data?.user?.dateOfBirth).format("YYYY-MM-DD");
      
      // Prepare signup data for Cognito (backend format)
      const signupData = {
        email: user.email,
        password: user.password,
        firstName: user.firstName,
        lastName: user.lastName,
        name: `${user.firstName} ${user.lastName}`,
        phone: user.phone,
        dateOfBirth: user.dateOfBirth,
        gender: data.profile.gender,
        religionId: data.profile.religionId,
        casteId: data.profile.casteId,
        motherTongueId: data.profile.motherTongueId,
        gothraId: data.profile.gothraId || 0,
      };
      
      // Use new Cognito signup
      const resUser = await VivahApi.Auth.signUp(signupData);
      // console.log(resUser);
      
      if (resUser) {
        setIsReg(true);
        
        setModal({
          isOpen: true,
          type: 'success',
          title: 'Registration Successful!',
          message: 'Please check your email for a verification code to complete your registration.'
        });
        
        // Set redirect destination
        setRedirectTo({
          path: "/verify-email",
          state: { email: user.email }
        });
      }
    } catch (error) {
      console.error("Registration error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Registration failed";
      setModal({
        isOpen: true,
        type: 'error',
        title: 'Registration Failed',
        message: errorMessage
      });
    }
  };

  // Intercept submit — show guardian prompt for female users before proceeding
  const handleFormSubmit = (data) => {
    if (data.profile.gender === 'F') {
      setPendingFormData(data);
      setGuardianPhone(data.user.phone);
      setShowGuardianPrompt(true);
    } else {
      onSubmit(data);
    }
  };

  const handleGuardianContinue = () => {
    setShowGuardianPrompt(false);
    onSubmit({ ...pendingFormData, user: { ...pendingFormData.user, phone: guardianPhone } });
  };

  const handleGuardianSkip = () => {
    setShowGuardianPrompt(false);
    onSubmit(pendingFormData);
  };

  const cancel = () => {
    window.location.href = "/login";
  };

  console.log('[Registration] render v2 - reg-form-wrap structure');

  return (
    <>
      <Modal
        isOpen={modal.isOpen}
        onClose={closeModal}
        type={modal.type}
        title={modal.title}
        message={modal.message}
        confirmText="OK"
      />
      
      {showGuardianPrompt && (
        <div className="guardian-overlay">
          <div className="guardian-modal">
            <div className="guardian-icon">
              <i className="ti ti-shield"></i>
            </div>
            <h3 className="guardian-title">Your Safety Matters</h3>
            <p className="guardian-msg">
              For your safety &amp; a more trusted experience, we recommend adding a{' '}
              <strong>parent or guardian's contact number</strong> instead of your own.
              <br /><br />
              You can update the number below or continue as-is.
            </p>
            <div className="guardian-phone-group">
              <label>Contact Number</label>
              <input
                type="text"
                value={guardianPhone}
                onChange={e => setGuardianPhone(e.target.value)}
                className="form-control"
                placeholder="+91XXXXXXXXXX"
              />
            </div>
            <div className="guardian-actions">
              <button className="btn guardian-btn-primary" onClick={handleGuardianContinue}>
                Continue
              </button>
              <button className="guardian-btn-skip" onClick={handleGuardianSkip}>
                Proceed with my own number
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="gla_page" id="gla_page">
        <a href="#gla_page" className="gla_top ti ti-angle-up gla_go"></a>
        <Header />
        <div
          className="gla_page_title gla_image_bck gla_wht_txt"
          data-color="#282828"
        >
          <div className="container text-left">
            <div className="row">
              <div className="col-md-8">
                <h1 className="gla_h1_title">Sign Up</h1>
              </div>
              <div className="col-md-4">
                <div className="breadcrumbs">
                  <a href="#">Home</a>
                  <span>Sign Up</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section id="gla_content" className="gla_content">
          <section className="gla_section">
            <div className="reg-form-wrap">
              <div className="reg-form-card">
                    {/* <form action="https://formspree.io/your@mail.com" method="POST"> */}
                    <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <div className="row">
                      <div className="col-md-6">
                        <label>Your First Name*</label>
                        <input
                          type="text"
                          name="firstName"
                          {...register("user.firstName")}
                          className={`form-control form-opacity ${
                            errors.user && errors.user.firstName
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.firstName?.message}
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label>Your Last Name*</label>
                        <input
                          type="text"
                          name="lastName"
                          {...register("user.lastName")}
                          className={`form-control form-opacity ${
                            errors.user && errors.user.lastName
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.lastName?.message}
                        </span>
                      </div>
                      <div className="col-md-4">
                        <label>Date of Birth*</label>
                        <input
                          type="date"
                          name="dateOfBirth"
                          {...register("user.dateOfBirth")}
                          className={`form-control form-opacity  ${
                            errors.user && errors.user.dateOfBirth
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.dateOfBirth?.message}
                        </span>
                      </div>
                      <div className="col-md-4">
                        <label>Gender*</label>
                        <select
                          name="gender"
                          {...register("profile.gender")}
                          className={`form-control form-opacity border-radius-0 ${
                            errors.profile && errors.profile.dateOfBirth
                              ? "is-invalid"
                              : ""
                          }`}
                        >
                          <option value="">Select Gender</option>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                          <option value="T">Transgender</option>
                        </select>
                        <span className="invalid-feedback">
                          {errors.profile && errors.profile.gender?.message}
                        </span>
                      </div>
                      <div className="col-md-4">
                        <label>Religion*</label>
                        <select
                          name="religion"
                          {...register("profile.religionId")}
                          className={`form-control form-opacity border-radius-0 ${
                            errors.profile && errors.profile.religionId
                              ? "is-invalid"
                              : ""
                          }`}
                          onChange={handleReligionChange}
                        >
                          <option value="">Select Religion</option>
                          {religionId.map((e) => {
                            return (
                              <option key={e.id} value={e.id}>
                                {e.label || e.value || e.name || e.id}
                              </option>
                            );
                          })}
                        </select>
                        <span className="invalid-feedback">
                          {errors.profile && errors.profile.religionId?.message}
                        </span>
                      </div>
                      <div className="col-md-4">
                        <label>Caste*</label>
                        <select
                          name="caste"
                          {...register("profile.casteId")}
                          className={`form-control form-opacity border-radius-0 ${
                            errors.profile && errors.profile.casteId
                              ? "is-invalid"
                              : ""
                          }`}
                        >
                          <option value="">Select caste</option>
                          {casteId.map((e) => {
                            return (
                              <option key={e.id} value={e.id}>
                                {e.label || e.value || e.name || e.id}
                              </option>
                            );
                          })}
                        </select>
                        <span className="invalid-feedback">
                          {errors.profile && errors.profile.religionId?.message}
                        </span>
                      </div>
                      {showGothras && (
                        <div className="col-md-4">
                          <label>Gothra*</label>
                          <select
                            {...register("profile.gothraId")}
                            className={`form-control form-opacity border-radius-0 ${
                              errors.profile && errors.profile.gothraId
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option value="">Select Gothra</option>
                            {gothraId.map((e) => {
                              return (
                                <option key={e.id} value={e.id}>
                                  {e.label || e.value || e.name || e.id}
                                </option>
                              );
                            })}
                          </select>
                          <span className="invalid-feedback">
                            {errors.profile && errors.profile.gothraId?.message}
                          </span>
                        </div>
                      )}
                      <div className="col-md-4">
                        <label>Mother Tongue*</label>
                        <select
                          {...register("profile.motherTongueId")}
                          className={`form-control form-opacity border-radius-0 ${
                            errors.profile && errors.profile.motherTongueId
                              ? "is-invalid"
                              : ""
                          }`}
                        >
                          <option value="">Select Mother Tongue</option>
                          {motherTongueId.map((e) => {
                            return (
                              <option key={e.id} value={e.id}>
                                {e.label || e.value || e.name || e.id}
                              </option>
                            );
                          })}
                        </select>
                        <span className="invalid-feedback">
                          {errors.profile &&
                            errors.profile.motherTongueId?.message}
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label>Your e-mail*</label>
                        <input
                          type="text"
                          name="email"
                          {...register("user.email")}
                          className={`form-control form-opacity ${
                            errors.user && errors.user.email ? "is-invalid" : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.email?.message}
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label>Your Mobile*</label>
                        <input
                          type="text"
                          name="phone"
                          {...register("user.phone")}
                          className={`form-control form-opacity ${
                            errors.user && errors.user.phone ? "is-invalid" : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.phone?.message}
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label>Password*</label>
                        <input
                          type="password"
                          name="password"
                          {...register("user.password")}
                          className={`form-control form-opacity ${
                            errors.user && errors.user.password
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.password?.message}
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label>Confirm Password*</label>
                        <input
                          type="password"
                          name="confirmPwd"
                          {...register("user.confirmPwd")}
                          className={`form-control form-opacity ${
                            errors.user && errors.user.confirmPwd
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <span className="invalid-feedback">
                          {errors.user && errors.user.confirmPwd?.message}
                        </span>
                      </div>
                      <div className="col-md-12">
                        <input
                          type="checkbox"
                          name="agree"
                          checked={agree}
                          onChange={(e) => setAgree(!agree)}
                        />
                        <span>
                          I Agree to Vivahbandh{" "}
                          <a href="/terms-conditions" target="_blanck">
                            Terms & Condition
                          </a>
                        </span>
                        <br />
                        <span className="invalid-feedback">
                          {errors.user && errors.agree?.message}
                        </span>
                      </div>
                      <div className="col-md-12">
                        <div className="reg-btn-group">
                          <input
                            type="submit"
                            className="btn submit"
                            value="Sign Up"
                            disabled={!agree}
                          />
                         
                        </div>
                        
                        {isReg && (
                          <div className="reg-success">
                            Registration successfull.
                          </div>
                        )}
                      </div>
                    </div>
                    </form>
              </div>
            </div>
          </section>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Registration;
